import React from 'react';
import { Phone, Mail, Clock, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { businessInfo, serviceStates } from '../mock/data';

const Footer = () => {
  const handleCallClick = () => {
    window.location.href = `tel:${businessInfo.phoneTel}`;
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${businessInfo.email}`;
  };

  return (
    <footer className="bg-[#152238] text-white">
      {/* CTA Section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold">
              Ready to Find Your Perfect Health Insurance Plan?
            </h2>
            <p className="text-xl text-[#A8B5C8] max-w-2xl mx-auto">
              Contact us today for a free consultation and personalized guidance.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
              <Button 
                size="lg" 
                onClick={handleCallClick}
                className="bg-white text-[#3B5275] hover:bg-blue-50 font-semibold text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
              >
                <Phone className="w-5 h-5 mr-2" />
                {businessInfo.phone}
              </Button>
              <Button 
                size="lg" 
                onClick={handleEmailClick}
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-[#3B5275] font-semibold text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
              >
                <Mail className="w-5 h-5 mr-2" />
                Email Us
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">{businessInfo.name}</h3>
            <p className="text-[#A8B5C8] mb-6">
              Your trusted partner for ACA marketplace and private health insurance plans.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Clock className="w-5 h-5 text-[#A8B5C8]" />
                <span className="text-[#A8B5C8]">{businessInfo.hours}</span>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div>
                <div className="text-sm text-[#A8B5C8] mb-1">Phone</div>
                <a 
                  href={`tel:${businessInfo.phoneTel}`}
                  className="text-white hover:text-[#A8B5C8] transition-colors font-medium"
                >
                  {businessInfo.phone}
                </a>
              </div>
              <div>
                <div className="text-sm text-[#A8B5C8] mb-1">Email</div>
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="text-white hover:text-[#A8B5C8] transition-colors font-medium"
                >
                  {businessInfo.email}
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => alert('Booking system will be integrated. Thank you for your interest!')}
                  className="text-[#A8B5C8] hover:text-white transition-colors cursor-pointer text-left"
                >
                  Book Appointment
                </button>
              </li>
              <li>
                <Link 
                  to="/privacy-policy"
                  className="text-[#A8B5C8] hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-conditions"
                  className="text-[#A8B5C8] hover:text-white transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4 text-sm">
            <Link 
              to="/privacy-policy" 
              className="text-[#A8B5C8] hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-[#A8B5C8]">•</span>
            <Link 
              to="/terms-conditions" 
              className="text-[#A8B5C8] hover:text-white transition-colors"
            >
              Terms & Conditions
            </Link>
          </div>
          <p className="text-[#A8B5C8] text-sm">
            © {new Date().getFullYear()} {businessInfo.name} LLC. All rights reserved.
          </p>
          <p className="text-[#A8B5C8] text-xs mt-2">
            Licensed insurance agency offering ACA marketplace and private health insurance plans.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
